import config from '@app/config'

import { createSelector } from '@app/utils/createSelector'

import { createReduxSlice } from '@app/store/redux_slice'
import type { ConfigState } from '@app/store/types/config'

const DEFAULT_CONFIG: ConfigState = {
  ...config,
  href: '',
  origin: '',
  userAgent: '',
  userAgentData: null,
  country: 'RU',
  isPolygon: false,
  isApp: false,
  appProtocol: 0,
  online: true,
  build: {
    sha: GIT_SHA || null,
    needsReload: false,
  },
}

const configSlice = createReduxSlice<ConfigState>('config')

export const configSelector = createSelector([configSlice.selector], config => config ?? DEFAULT_CONFIG)

export const setConfigSlice = (partialConfig: Partial<ConfigState>) => configSlice.update(state => ({ ...(state ?? DEFAULT_CONFIG), ...partialConfig }))

export const setBuildShaSlice = (build: {
  sha: string
  /** Forces the reload flag; when omitted it follows from the sha difference. */
  needsReload?: boolean
}) => configSlice.update(state => applyBuildSha(state ?? DEFAULT_CONFIG, build))

export function applyBuildSha(state: ConfigState, payload: { sha: string; needsReload?: boolean }): ConfigState {
  if (!('needsReload' in payload) && state.build.sha === payload.sha) return state

  const needsReload =
    'needsReload' in payload ? !!payload.needsReload : state.build.needsReload || (state.build.sha !== null && state.build.sha !== payload.sha)

  return {
    ...state,
    build: {
      ...state.build,
      sha: payload.sha,
      needsReload,
    },
  }
}
